import { Component, OnInit ,ViewChild} from '@angular/core';
import {WorkgroupService} from '../workgroup-services/workgroup.service'
import {ActivatedRoute, Params,Router} from '@angular/router';
import { routerNgProbeToken } from '@angular/router/src/router_module';
import { MatDialog,MatSnackBar} from '@angular/material';
import {VisitorComponent} from '../visitor/visitor.component'
import {DeletePopupComponent} from '../../organization/Popups/delete-popup/delete-popup.component'
import {StaticValueService} from '../../shared/services/static-value.service'
import {AuthService} from '../../shared/services/auth/auth.service'
import {AssociateService} from '../../associate/shared/services/associate.service'
import { MobileNavService } from '../../shared/services/mobile-nav.service';
import * as moment from 'moment'
import {NgForm, FormsModule} from '@angular/forms';
import {Sort} from '@angular/material';
import { ToastService } from '../../shared/services/toast.service'
import {Location} from '@angular/common';
import { Configuration } from '../../app.constants';
import { NotificationService } from '../../shared/services/notification.service';

@Component({
  selector: 'app-workgroup-profile',
  templateUrl: './workgroup-profile.component.html',
  styleUrls: ['./workgroup-profile.component.css']
})


export class WorkgroupProfileComponent implements OnInit {
  // variables
//  public Id:any;
@ViewChild('myForm')
private myForm: NgForm ;
  public members:any=[]
  public isPublic=false;
  public show=true;
  public isUpdate=false;
  public search='';
  public associates:any;
  public serverApiUrl;
  public dropdown: any;
  public group:any;
  public user:any;
  public isAdmin: boolean=false;
  public oldMember={'fullName':'', 'startDate': '', 'endDate': '', 'role': '', 'status': false}
  public addedAssociates: any;
  // tslint:disable-next-line:max-line-length
  public groupUpdate = { groupname: '', groupstatus: '', grouptype: '', groupalias: '', privacysetting: '', startDate: '', endDate: '', scope: '', url: '', description: '', comments: ''}
  public message= '';
  public length = 100;
  public pageSize = 5;
  public pageindex=0;
  public pageSizeOptions = [ 5, 10, 25, 50, 100];
  public Coordinator:any=0;
  public Chair:any=0;
  public errors:any;

  constructor( public service: WorkgroupService,
  public route: ActivatedRoute,
  public dialog: MatDialog,
  public snackBar: MatSnackBar,
  public router: Router,
  public staticDDListService: StaticValueService,
  public auth: AuthService,
  public associateService: AssociateService,
  public mobileNav: MobileNavService,
  public toastService:ToastService,
  public _location: Location,
  public config: Configuration,
  public notificationService:NotificationService,
  ) { }


  ngOnInit() {
    this.serverApiUrl = this.config.StaticImageUrl;
    this.user = this.auth.user;
    this.dropdown = this.staticDDListService.staticData["staticDD"]["workingGroup"];
    this.errors = this.staticDDListService.errors;
    this.associates = Object.assign([], this.route.snapshot.data['associates']);
    this.group = Object.assign({}, this.route.snapshot.data['workGroup'])[0];
    this.length = this.group.Members.length;
    this.members = this.group.Members.slice(0,this.pageSize)
    if(!this.group.endDate){
      this.group.groupStatus = 'Active'      
    } else if (moment(this.group.startDate).diff(moment(), 'days') <=0  && moment().diff(moment(this.group.endDate), 'days') < 0 ) {
      this.group.groupStatus = 'Active'
    } else {
      this.group.groupStatus = 'Inactive';
    }

   
    if (this.user.role === 'Admin' || this.user.role === 'Super Admin' || this.group.hrId=== this.user.associateId){
      this.isAdmin = true;
      this.isPublic = true;
    }


    if(this.group.groupStatus === 'Active'){
      this.group.Members.forEach(member => {
        if((moment(member.startDate).diff(moment(), 'days') <=0  && moment().diff(moment(member.endDate), 'days') < 0) || !member.endDate ){
          member.status = true;
        } else {
          member.status = false;
        }
      });
    }

    this.group.Members.filter(member => {
      if(this.group.groupStatus === 'Inactive'){
        member.status = false;
      }
      if (member.associateId === this.user.associateId && (member.role === 'Coordinator' || member.role === 'Chair')){
        this.isPublic = true;
        this.isAdmin = true;
      }
      if(member.role === 'Coordinator'){
        this.Coordinator+=1;
      }else if(member.role === 'Chair'){
        this.Chair+=1;
      }
    })

    this.group.Members.filter(x => {
     if (x.associateId === this.user.associateId)
       this.isPublic = true;
       if(x.startDate>x.endDate){
         x.status=false;
       }
    });
    this.service.updateWorkGroup(this.group).then(res=>{});
    if (this.isAdmin){
      this.isPublic = true;
    }

    if(this.group.approval !== 'Approved' && this.group.lastEditedBy[0].id === this.user.associateId){
      this.isAdmin =true;
      this.isPublic = true;
    }

    if(this.group.privacySetting === 'Private' && !this.isAdmin){
      this.router.navigate(['/home/working-group/search']);
    }

    
  }


  // swap between member and detail
  Swap(){
    this.show = !this.show;
  }

  onClickMe() {
    this.mobileNav.showSideNav();
 }

  // update Form display
  Update(){
    this.groupUpdate.groupname = this.group.groupName;
    this.groupUpdate.groupstatus = this.group.groupStatus;
    this.groupUpdate.grouptype = this.group.groupType;
    this.groupUpdate.groupalias = this.group.groupAlias;
    this.groupUpdate.privacysetting = this.group.privacySetting;
    this.groupUpdate.startDate = this.group.startDate;
    this.groupUpdate.endDate = this.group.endDate;
    this.groupUpdate.url = this.group.communityPage;
    this.groupUpdate.description = this.group.description;
    this.groupUpdate.comments = this.group.groupComments;
    this.groupUpdate.scope = this.group.scope;
    if (!this.oldMember.fullName)
      this.isUpdate = !this.isUpdate;
    else
    this.toastService.error(this.errors.Workgroup["406"]);
  }


  ArchiveGroup(){
    const dialogRef = this.dialog.open(DeletePopupComponent, {
      width: '300px',
      data: {
      title: `You want to remove '${this.group.groupAlias}' ?`
      },
    });
    dialogRef.afterClosed().subscribe(res => {
      var isApproved=this.group.approval;
        if (res === 'Proceed'){
          this.group.approval = 'Archive';
          this.group.endDate = new Date();
          this.group.Members.filter(member => {
            if (member.associateId)
            this.associateService.getAssociate(member.associateId).subscribe(associate => {
                associate['data'][0].workGroupsAndCommittees = associate['data'][0].workGroupsAndCommittees.filter(group => {
                    if (this.group._id !== group.workingGroupId)
                      return group;
                });
                this.associateService.updateAssociateWorkingGroup(associate['data'][0]).subscribe(res => {
                  if(isApproved==='Approved'){
                    this.service.workgroupArchiveNotification(member.associateId,this.group.groupAlias,this.group._id);
                  }
                  console.log('Associate updated:', res)
                }, error => {
                  console.log('associate error', error)
                });
            });
          });
          this.service.updateWorkGroup(this.group).then(res=>{
            this.toastService.success();
            this.router.navigate(['/home/working-group/search']);
          },err=>{
            console.log(err)
          });
        }
    });
    this.length=this.group.Members.length;
    this.members=this.group.Members.slice(this.pageSize*this.pageindex,this.pageSize*this.pageindex+this.pageSize)

}

  // display new visitor popup
  addExternalMember(){
    const dialogRef = this.dialog.open(VisitorComponent, {
      width: '450px',
      data: {
      group: this.group
      },
    });
    dialogRef.afterClosed().subscribe(res=>{
      if(res !== undefined){
        res.status =(moment(res.startDate).diff(moment(), 'days') <=0  && moment().diff(moment(res.endDate), 'days') <= 0) || !res.endDate;
        this.group.Members.unshift(res);
        this.length = this.group.Members.length;
        this.members = this.group.Members.slice(this.pageSize*this.pageindex,this.pageSize*this.pageindex+this.pageSize)  
        this.service.updateWorkGroup(this.group).then();
      }
    })
  }
  updateWorkGroup() {
    if (!this.myForm.valid) {
      return ;
    }
    this.group.groupName = this.groupUpdate.groupname;
    this.group.groupType = this.groupUpdate.grouptype;
    this.group.groupAlias = this.groupUpdate.groupalias;
    this.group.privacySetting = this.groupUpdate.privacysetting;
    this.group.startDate = this.groupUpdate.startDate;
    this.group.endDate = this.groupUpdate.endDate;
    this.group.communityPage = this.groupUpdate.url;
    this.group.description = this.groupUpdate.description;
    this.group.groupComments = this.groupUpdate.comments;
    this.group.scope = this.groupUpdate.scope;

    // tslint:disable-next-line:max-line-length
    if(!this.group.endDate){
      this.group.groupStatus = 'Active'      
    } else if (moment(this.group.startDate).diff(moment(), 'days') <=0  && moment().diff(moment(this.group.endDate), 'days') <= 0 ) {
      this.group.groupStatus = 'Active'
    } else {
      this.group.groupStatus = 'Inactive';
    }

    this.group.Members.forEach(member => {
      member.status =((moment(member.startDate).diff(moment(), 'days') <=0  && moment().diff(moment(member.endDate), 'days') <= 0) || !member.endDate) && ((moment(this.group.startDate).diff(moment(), 'days') <=0  && moment().diff(moment(this.group.endDate), 'days') <= 0) || !this.group.endDate);
    });

    
    this.group.lastEditedBy.unshift({name: this.user.isProxyUser ? this.user.name + ` (${this.user.proxyUser.fullName})` : this.user.name, id: this.user.associateId, time: new Date()})
    let g = {
      workingGroupId: this.group._id,
      alias: this.group.groupAlias,
      description: this.group.description,
      status: this.group.groupStatus,
      scope: this.group.scope,
      startDate: this.group.startDate,
      endDate: this.group.endDate,
      privacy: this.group.privacySetting,
      type : this.group.groupType,
      membersCount : this.group.Members.length,
    }
    if (this.group.approval === 'Disapproved') {
      this.group.approval = 'pending';
     
      this.associateService.getAssociate(this.user.associateId).subscribe(associate => {
      
        associate['data'][0]['workGroupsAndCommittees'] = associate['data'][0]['workGroupsAndCommittees'].filter(gr => {
          if (this.group._id === gr.workingGroupId)
            gr.approval = 'pending';
          return gr;
      })
        this.associateService.updateAssociateWorkingGroup(associate['data'][0]).subscribe(res => {
          console.log(res);
        }); ;
      });
      const message = `Workgroup <span class='fw-bold d-inline'>${this.group.groupAlias}</span> created by <span class='fw-bold d-inline'>${this.user.isProxyUser ? this.user.name + ` (${this.user.proxyUser.fullName})` : this.user.name}</span> on <span class='fw-bold d-inline'>${moment(this.group.reqestedDate).format('DD MMM YYYY')}</span> requires your approval. Click here to proceed to approval page.`
      this.notificationService.sendActionMessage(this.group.lastValidatedBy.id, message, `/home/working-group/profile-hr/${this.group._id}`, 'Validation', 'Workgroup', 'Approved', 'Disapproved', this.group._id, 'Approval');
    }
    this.service.updateWorkGroup(this.group);
    this.length=this.group.Members.length;
    this.members=this.group.Members.slice(this.pageSize*this.pageindex,this.pageSize*this.pageindex+this.pageSize)
    this.toastService.success();
    // this.snackBar.open('Workgroup Updated', '', {duration: 2000, });
    this.isUpdate = !this.isUpdate;
  }


// members function
// Member is need update
  updateMember(member: any){
    if (this.isUpdate)
      this.toastService.error(this.errors.Workgroup["405"]);
    else if (!this.oldMember.fullName){
      this.makecopy(this.oldMember, member)
//      this.oldMember=member;
      member.isUpdate = true;
    }
    // tslint:disable-next-line:one-line
    else{
      this.toastService.error(`First Update ${this.oldMember.fullName}`);
    }

  }

  acceptUpdatedMember(member: any) {
    this.group.lastEditedBy.unshift({name: this.user.isProxyUser ? this.user.name + ` (${this.user.proxyUser.fullName})` : this.user.name, id: this.user.associateId, time: new Date()})
    if(member.associateId==this.user.associateId && (member.role !== 'Coordinator' && member.role !== 'Chair')){
      if (this.user.role === 'Admin' || this.user.role === 'Super Admin' ||  this.user.associateId === this.group.hrId ){
        
      }else{
        this.isPublic=true;
        this.isAdmin=false;
      }    
    }
    if(member.role!==this.oldMember.role){
      if (member.role==='Chair') {
        this.Chair+=1;
      }
      if (this.oldMember.role==='Chair'){
        this.Chair-=1;
      }
      
      if(this.Chair<1){
        this.Chair+=1;
        this.toastService.error(this.errors.Workgroup["404"]);
        return;
      }
      this.service.roleChangeNotification(member.associateId,this.oldMember.role,member.role,this.group.groupAlias,this.user.isProxyUser ? this.user.name + ` (${this.user.proxyUser.fullName})` : this.user.name,this.group._id);
    }
    member.status =(moment(member.startDate).diff(moment(), 'days') <=0  && moment().diff(moment(member.endDate), 'days') <= 0) || !member.endDate;
    this.oldMember = {'fullName': '', 'startDate': '', 'endDate': '', 'role': '', 'status': false};
    member.isUpdate = false;
    this.service.updateWorkGroup(this.group);
    this.length=this.group.Members.length;
    this.members=this.group.Members.slice(this.pageSize*this.pageindex,this.pageSize*this.pageindex+this.pageSize)

  }
  cancelUpdatedMember(member: any) {
    this.makecopy(member, this.oldMember)
    this.oldMember = {'fullName': '', 'startDate': '', 'endDate': '', 'role': '', 'status': false};
  }
  makecopy(to: any, from: any) {
    to.fullName = from.fullName;
    to.startDate = from.startDate;
    to.endDate = from.endDate;
    to.role = from.role,
    to.status = from.status;
    to.isUpdate = from.isUpdate;
  }
  // remove member
  removeMember(_member: any) {
    const dialogRef = this.dialog.open(DeletePopupComponent, {
      width: '300px',
      data: {
      title: `You want to remove '${_member.fullName}' ?`
      },
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res === 'Proceed') {
        if(this.Chair <= 1 && _member.role === 'Chair' && this.group.Members.length > 1) {
          this.toastService.error(this.errors.Workgroup['404']);
          return;
        }else if(_member.role==='Chair'){
          this.Chair-=1;
        }else if(_member.role==='Coordinator' && this.group.approval ==='Approved'){
          this.group.Members.forEach(mem => {
            if(mem.role==='Chair'){
              if(this.user.associateId===_member.associateId){
                // tslint:disable-next-line:max-line-length
                this.service.sendNotification(mem.associateId, `<span class='fw-bold d-inline'>${_member.fullName}</span> leave workgroup <span class='fw-bold d-inline'>${this.group.groupAlias}</span>, select someone as a Coordinator`, this.group._id);
              }else {
                // tslint:disable-next-line:max-line-length
                this.service.sendNotification(mem.associateId, `<span class='fw-bold d-inline'>${_member.fullName}</span> has been removed from workgroup <span class='fw-bold d-inline'>${this.group.groupAlias}</span>, select someone as a Coordinator`, this.group._id);
               }

            }
          });
        }

        this.group.lastEditedBy.unshift({name: this.user.isProxyUser ? this.user.name + ` (${this.user.proxyUser.fullName})` : this.user.name, id: this.user.associateId, time: new Date()})
        
        this.group.Members = this.group.Members.filter(member => {
          // tslint:disable-next-line:curly
          if (_member !== member)
            {return member;}
        });

        if(this.group.approval==='Approved'){
          // tslint:disable-next-line:curly
          this.associateService.getAssociate(_member.associateId).subscribe(associate => {
            associate['data'][0]['workGroupsAndCommittees'] = associate['data'][0]['workGroupsAndCommittees'].filter(gr => {
              // tslint:disable-next-line:curly
              if (this.group._id !== gr.workingGroupId)
                return gr;
            })  
            this.associateService.updateAssociateWorkingGroup(associate['data'][0]).subscribe(res => {
              this.service.sendMail(_member, this.group, -1);
            });
          });
        }

            
        if (this.group.Members.length==0) {
          this.group.groupStatus = 'Archive';
          this.group.endDate = new Date();
          this.service.updateWorkGroup(this.group);
          this.router.navigate(['/home/working-group/search']);
        } else {
          this.service.updateWorkGroup(this.group);  
        }
        if(_member.associateId===this.user.associateId ){
          this.isAdmin=false;
          this.isPublic=true;
        }
        if(this.user.role === 'Admin'){
          this.isAdmin=true;
          this.isPublic = true;
        }
      }
      this.members=this.group.Members.slice(this.pageSize*this.pageindex,this.pageSize*this.pageindex+this.pageSize)
      this.length=this.group.Members.length;
      })
  }

  // add new member to work group
addMember(associate: any){
  this.associates = this.associates.filter(x => {
    if (x !== associate)
      return x;
    })

  const newMember = {
    'fullName': associate.personalInformation.fullName,
    'associateId': associate._id,
    'jobTitle': associate.jobDescription.jobTitle,
    'designation': associate.jobDescription.company.name,
    'designationID':associate.jobDescription.company.id,
    'email': associate.workContactDetails.workEmail,
    'startDate': new Date(),
    'endDate': this.group.endDate? this.group.endDate: '',
    'role': 'Member',
    'status': (moment(this.group.startDate).diff(moment(), 'days') <=0  && moment().diff(moment(this.group.endDate), 'days') <= 0) || !this.group.endDate,
    'contactNumber': associate.workContactDetails.workMobile,
    'landLineNumber': associate.workContactDetails.workLandline,
    'isUpdate': false,
    'imageUrl': associate.personalInformation.avatarUrl
  }
 
  let isMember = false;
    this.group.Members.filter(added => {
      if (added.associateId === associate._id){
        isMember = true;
        return;
      }
    });
    
    if (isMember){
      return;
    }

    this.group.lastEditedBy.unshift({name: this.user.isProxyUser ? this.user.name + ` (${this.user.proxyUser.fullName})` : this.user.name, id: this.user.associateId, time: new Date()})
      
    const g = {
      workingGroupId: this.group._id,
      alias: this.group.groupAlias,
      description: this.group.description,
      status: this.group.groupStatus,
      scope: this.group.scope,
      startDate: this.group.startDate,
      endDate: this.group.endDate,
      approval: this.group.approval,
      privacy: this.group.privacySetting,
      type : this.group.groupType,
      membersCount : this.group.Members.length
    }

    if (this.group.Members.length > 0) {
      this.group.Members.push(newMember)

      if (this.group.approval === 'Approved'){
        this.associateService.getAssociate(newMember.associateId).subscribe(associate => {
          if (associate['data'][0]['workGroupsAndCommittees']){
            associate['data'][0]['workGroupsAndCommittees'].push(g)
          }else
            associate['data'][0]['workGroupsAndCommittees'] = [g];
          this.associateService.updateAssociateWorkingGroup(associate['data'][0]).subscribe(res => {
            this.service.sendMail(newMember, this.group, 0).then(res => {
            })
          }); ;
        })
      }
      this.toastService.success();
      this.service.updateWorkGroup(this.group);
    }else{
      this.group.Members.push(newMember)
      if (this.group.approval === 'Approved')
        this.associateService.getAssociate(newMember.associateId).subscribe(associate => {
          if (associate['data'][0]['workGroupsAndCommittees'][0].workingGroupId){
            associate['data'][0]['workGroupsAndCommittees'].push(g)
          }else
          associate['data'][0]['workGroupsAndCommittees'] = [g];
          this.associateService.updateAssociateWorkingGroup(associate['data'][0]).subscribe(res => {
            console.log(res);
          });
        })
      this.service.updateWorkGroup(this.group);
      this.toastService.success();
    }
    this.length=this.group.Members.length;
    this.members=this.group.Members.slice(this.pageSize*this.pageindex,this.pageSize*this.pageindex+this.pageSize)

  }

associateSearch() {
  this.associateService.getAllAssociatesFilter(this.search, '', '').subscribe(data => {
    this.associates = data;
  })
}



  getServerData(event) {
    this.pageSize=event.pageSize;
    this.pageindex=event.pageIndex;
    this.members=this.group.Members.slice(this.pageSize*this.pageindex,this.pageSize*this.pageindex+this.pageSize)
  }

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    this.pageSizeOptions = setPageSizeOptionsInput.split(',').map(str => +str);
  }

  sortData(sort: Sort) {
    let data = Object.assign([],this.group.Members);

    if (!sort.active || sort.direction == '') {
      this.members = data.slice(this.pageSize*this.pageindex,this.pageSize*this.pageindex+this.pageSize);
      return;
    }
    let isAsc = sort.direction == 'asc';
    this.members = data.sort((a, b) => {
        switch (sort.active) {
          case 'name': return this.compare(a.fullName.toLowerCase(), b.fullName.toLowerCase(), isAsc);
          case 'organization': return this.compare(a.designation.toLowerCase(), b.designation.toLowerCase(), isAsc);
          case 'role': return this.compare(a.role.toLowerCase(), b.role.toLowerCase(), isAsc);
          case 'startDate': return this.compare(a.startDate, b.startDate, isAsc);
          case 'endDate': return this.compare(a.endDate?a.endDate:this.group.endDate, b.endDate?b.endDate:this.group.endDate, isAsc);
          case 'status': return this.compare(a.status, b.status.toLowerCase(), isAsc);
          default: return 0;
        }        
    });
    this.members=this.members.slice(this.pageSize*this.pageindex,this.pageSize*this.pageindex+this.pageSize)
    
  }
  backBtnClick(){
    this._location.back();
  }
  compare(a, b, isAsc) {
    return (a === b ? 0 : (a < b ? -1 : 1) * (isAsc ? 1 : -1));
  }
}
